import React from "react";

export const daysSinceInspectionBodyTemplate = (rowData: any) => {
    if (!rowData.inspection) {
        return <React.Fragment></React.Fragment>;
    }

    const dateOfInspection = new Date(rowData.inspection.dateOfInspection);
    const daysSinceInspected = rowData.inspection.daysSince;

    const today = new Date();
    if (
        daysSinceInspected === null ||
        daysSinceInspected === undefined ||
        today < dateOfInspection
    ) {
        return <React.Fragment></React.Fragment>;
    }

    return (
        <React.Fragment>
            <div>
                <p>{daysSinceInspected}</p>
            </div>
        </React.Fragment>
    );
};
